// CallbackComponent.js

import React, { useEffect } from 'react';


const CallbackComponent = () => {
 

  useEffect(() => {
    // Extract code from URL
    const code = new URLSearchParams(window.location.hash.substr(1)).get('code');
    
    // Use the code as needed (e.g., exchange for tokens)
    console.log('Authorization Code:', code);
    localStorage.setItem('code', code)

    // Continue with your authentication flow...
  }, []);


  return (
    <div>
      <p>Redirecting...</p>
    </div>
  );
};

export default CallbackComponent;
